module.exports = __webpack_public_path__ + "static/img/fail.6fc4818.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fail.png
// module id = fhya
// module chunks = 1